import {
  IChargeUnit,
  IKepcoTou,
  ISeasonMapping,
  ITouPeriods,
} from './algoInterface'

export const touPeriods: ITouPeriods = {
  spr: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid', //8
      'mid',
      'mid',
      'max', //11
      'mid',
      'max', //13
      'max',
      'max',
      'max',
      'max',
      'mid', //18
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  sum: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid', //8
      'mid',
      'mid',
      'max', //11
      'mid',
      'max', //13
      'max',
      'max',
      'max',
      'max',
      'mid', //18
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  fall: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid', //8
      'mid',
      'mid',
      'max', //11
      'mid',
      'max', //13
      'max',
      'max',
      'max',
      'max',
      'mid', //18
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  win: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid', //8
      'max', //9
      'max', //10
      'max', //11
      'mid', //12
      'mid', //13
      'mid',
      'mid', //15
      'max', //16
      'max', //
      'max', //18
      'mid',
      'mid',
      'mid', //21
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid', //8
      'mid', //9
      'mid', //10
      'mid', //11
      'mid', //12
      'mid', //13
      'mid',
      'mid', //15
      'mid', //16
      'mid', //
      'mid', //18
      'mid',
      'mid',
      'mid', //21
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
}

export const seasonMapping: ISeasonMapping = {
  3: 'spr',
  4: 'spr',
  5: 'spr', // 3월, 4월, 5월은 spring
  6: 'sum',
  7: 'sum',
  8: 'sum', // 6월, 7월, 8월은 summer
  9: 'fall',
  10: 'fall', // 9월, 10월은 fall
  11: 'win',
  12: 'win',
  1: 'win',
  2: 'win', // 11월, 12월, 1월, 2월은 winter
}

export const holidayData = [
  20230101, 20230121, 20230122, 20230123, 20230124, 20230301, 20230505,
  20230527, 20230606, 20230815, 20230928, 20230929, 20230930, 20231003,
  20231009, 20231225,
]

export const chargeUnit: IChargeUnit = {
  spr: {
    min: 87.2,
    mid: 92.0,
    max: 111.2,
  },
  sum: {
    min: 87.2,
    mid: 113.0,
    max: 146.5,
  },
  fall: {
    min: 87.2,
    mid: 92.0,
    max: 111.2,
  },
  win: {
    min: 94.6,
    mid: 111.5,
    max: 140.9,
  },
}

export const kepkoTou: IKepcoTou = {
  name: '고압A 선택1',
  defaultChargeUnit: 6490,
  chargeUnit: chargeUnit,
}
